module.exports = __webpack_public_path__ + "static/media/4.d0951e04.png";